// src/components/ConfirmDeleteModal.js

import React from 'react';

/**
 * ConfirmDeleteModal component prompts the admin to confirm deletion actions.
 */
function ConfirmDeleteModal({ isOpen, title, message, target, onConfirm, onCancel }) {
  // If using the old API with target
  let displayMessage = message;
  if (!message && target) {
    if (target.type) {
      const isUser = target.type === 'user';
      const itemType = isUser ? 'User' : 'Video';
      displayMessage = `Are you sure you want to delete this ${itemType}? This action cannot be undone.`;
    } else {
      displayMessage = 'Are you sure you want to delete this item? This action cannot be undone.';
    }
  }

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg w-full max-w-md p-6">
        <h2 className="text-xl font-semibold mb-4">{title || 'Confirm Deletion'}</h2>
        <p className="text-gray-700 mb-6">
          {displayMessage || 'Are you sure you want to delete this item? This action cannot be undone.'}
        </p>

        {/* Action Buttons */}
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="bg-gray-500 text-white px-4 py-2 rounded mr-2 hover:bg-gray-600 transition-colors duration-200"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition-colors duration-200"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDeleteModal;
